import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "align-items-center flex justify-content-center"
}
const _hoisted_2 = {
  key: 1,
  class: "align-items-center flex justify-content-center"
}
const _hoisted_3 = {
  key: 2,
  class: "align-items-center flex justify-content-center"
}
const _hoisted_4 = { class: "font-bold ml-2" }

import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import { useMessageCenterStore } from '@/store';
import { useAuthStore } from '@/store';
import MessageCenterBase from './components/MessageCenterBase';
import Chat from './components/Chat';
import ChatList from './components/ChatList';
import NewChat from './components/NewChat';
import { useTenant, can } from '@/composables';
import { MESSAGE_CENTER_EVENTS, TENANT_SETTINGS } from '@/enum';
import { echoService } from '@/utils';
import { ChatInterface, SyncDataFileMessage, SyncDataMessage } from '@/types/MessageCenter';
import DisplayChatName from './components/DisplayChatName';
import { PERMISSIONS } from '@/enum';

export default /*@__PURE__*/_defineComponent({
  __name: 'MessageCenter',
  setup(__props) {

const authStore = useAuthStore();
const messageCenter = useMessageCenterStore();
const { screen } = storeToRefs(messageCenter);

const $tenant = useTenant();

const isMessageCenterEnabled = () => {
  return $tenant.tenantSettingEnabled(TENANT_SETTINGS.MESSAGE_CENTER) && !authStore.isImpersonating;
};

const enableMessageCenter = isMessageCenterEnabled();

onMounted(() => init());

const init = async () => {
  if (!enableMessageCenter) return;
  messageCenter.$reset();
  messageCenter.getChats();
  messageCenter.getMessageSettings();
  screen.value = 'list-chats';
  setUpEcho();
};

const setUpEcho = async () => {
  const token = await authStore.token;
  const tenant = token?.tenant.id;
  if (!token) return;

  echoService.createEcho(token.access_token, tenant);
  echoService
    .getEcho()
    ?.private(`message_center.${authStore.user?.id}`)
    .listen(MESSAGE_CENTER_EVENTS.NEW_MESSAGE_SENT, (data: SyncDataMessage) => {
      messageCenter.syncDataMessage(data);
    })
    .listen(MESSAGE_CENTER_EVENTS.CHAT_CREATED, (chat: ChatInterface) => {
      messageCenter.chatCreated(chat);
    })
    .listen(MESSAGE_CENTER_EVENTS.CHAT_DELETED, (chat: ChatInterface) => {
      messageCenter.chatDeleted(chat);
    })
    .listen(MESSAGE_CENTER_EVENTS.MESSAGE_DELETED, (data: SyncDataMessage) => {
      messageCenter.messageDeleted(data);
    })
    .listen(MESSAGE_CENTER_EVENTS.MESSAGE_FILE_DELETED, (data: SyncDataFileMessage) => {
      messageCenter.messageFileDeleted(data);
    });
};

const openChatList = () => {
  screen.value = 'list-chats';
  messageCenter.currentChatId = undefined;
};

const goListChats = () => {
  screen.value = 'list-chats';
  messageCenter.currentChatId = undefined;
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_unref(enableMessageCenter))
    ? (_openBlock(), _createBlock(_unref(MessageCenterBase), { key: 0 }, {
        header: _withCtx(() => [
          (_unref(messageCenter).screen === 'list-chats')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "font-semibold text-xl text-primary-700" }, "Messages", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_unref(messageCenter).screen === 'new-chat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_Icon, {
                  name: "arrow_back_ios",
                  class: "icon-color font-bold cursor-pointer text-base text-color-secondary",
                  onClick: goListChats
                }),
                _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "font-bold ml-2 text-color-secondary" }, "New Message", -1))
              ]))
            : _createCommentVNode("", true),
          (_unref(messageCenter).screen === 'chat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Icon, {
                  name: "arrow_back_ios",
                  class: "icon-color font-bold cursor-pointer text-base text-color-secondary",
                  onClick: openChatList
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h3", _hoisted_4, [
            (_unref(messageCenter).getCurrentChat)
              ? (_openBlock(), _createBlock(_unref(DisplayChatName), {
                  key: 0,
                  name: _unref(messageCenter).getCurrentChat.name,
                  class: "max-w-14rem"
                }, null, 8, ["name"]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          (_unref(messageCenter).screen === 'list-chats' && _unref(can)([_unref(PERMISSIONS).CHAT_INDEX]))
            ? (_openBlock(), _createBlock(_unref(ChatList), { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(messageCenter).screen === 'new-chat' && _unref(can)([_unref(PERMISSIONS).CHAT_STORE]))
            ? (_openBlock(), _createBlock(_unref(NewChat), { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(messageCenter).screen === 'chat')
            ? (_openBlock(), _createBlock(_unref(Chat), { key: 2 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})